module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av234-ab7316a01f13763390dd5e339864ed0d.jpg";